// import axios from 'axios'

// All axios requests and responses are intercepted here.

export default function setup () {
  // Before each request
  // axios.interceptors.request.use(function (config) {
  //   config.headers.Authorization = 'TransactionKey ' + window.key
  //   return config
  // }, function (error) {
  //   return Promise.reject(error)
  // })
}
